export const TableFields = [
	'id',
	'versionId',
	'title',
	'created',
	'numberOfQuestions',
	'latestSent',
];
